import { create } from "zustand";

interface PastSessionsVisibilityState {
  showPast: boolean;
  toggleShowPast: () => void;
  showPastSessionsBySectionId: Record<string, boolean>;
  toggleShowPastSessionsBySection: (sectionId: string) => void;
  reset: () => void;
}

export const usePastSessionsVisibilityStore = create<PastSessionsVisibilityState>(set => ({
  showPast: false,
  toggleShowPast: () => set(state => ({ showPast: !state.showPast })),
  showPastSessionsBySectionId: {},
  toggleShowPastSessionsBySection: sectionId =>
    set(state => ({
      showPastSessionsBySectionId: {
        ...state.showPastSessionsBySectionId,
        [sectionId]: !state.showPastSessionsBySectionId[sectionId],
      },
    })),
  reset: () => set({ showPast: false, showPastSessionsBySectionId: {} }),
}));
